if (!customElements.get('multilayer-image')) {
    class MultilayerImage extends HTMLElement {
        constructor() {
            super();

            const firstItem = this.querySelector('.image-item:first-child');

            // Intersection Observer to animate first item in on scroll
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('item-active');
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '-100px 0px'
            });

            if (firstItem) {
                observer.observe(firstItem);
            }

            // Hover: expand hovered item, collapse others
            const allItems = this.querySelectorAll('.image-item');
            allItems.forEach(item => {
                item.addEventListener('mouseenter', function () {
                    if (!this.classList.contains('item-active')) {
                        allItems.forEach(i => i.classList.remove('item-active'));
                        this.classList.add('item-active');
                    }
                });
            });
        }
    }

    customElements.define('multilayer-image', MultilayerImage);
}